






import { Component, Prop, Vue } from 'vue-property-decorator';
import { MeetingDate } from './types';

@Component
export default class MentoringMeetingDate extends Vue {
  @Prop({ type: Object, required: true })
  readonly date!: MeetingDate;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/mentoring/modal/components/meeting/components/date/MentoringMeetingDate.vue